module.exports = __webpack_public_path__ + "img/xtnl-005.eb207911.png";